import React, { forwardRef } from 'react'
import { colors, ColorType } from '@styles/colors'
import { rounded } from '@styles/utils'
import { Block, BlockOverrides, BlockProps } from 'baseui/block'
import { useOverrides } from '../hooks/use-overrides'
import { border as borderStyle } from '@styles/utils'

interface BaseBlockProps extends BlockProps {
  className?: string
  columnGap?: string
  rowGap?: string
  flexbox?: boolean
  flexCenter?: boolean
  cursor?: 'pointer' | 'auto'
  column?: boolean
  rounded?: number
  boxSizing?: 'border-box' | 'content-box'
  spaceBetween?: boolean
  alignCenter?: boolean
  justifyCenter?: boolean
  zIndex?: number
  userSelect?: 'none' | 'auto'
  border?: {
    color?: ColorType
    width?: (string | number | void | null)[]
    style?: string
  }
}

const BaseBlockComponent = forwardRef<HTMLDivElement, BaseBlockProps>(
  (
    {
      children,
      overrides,
      className,
      columnGap,
      rowGap,
      flexbox,
      cursor,
      column,
      flexCenter,
      rounded: borderRadius,
      boxSizing,
      spaceBetween,
      alignCenter,
      justifyCenter,
      zIndex,
      border,
      userSelect,
      onClick,
      ...props
    },
    ref
  ) => {
    return (
      <Block
        onClick={onClick}
        ref={ref}
        className={className}
        overrides={useOverrides<BlockOverrides>(
          {
            Block: {
              style: {
                columnGap,
                rowGap,
                boxSizing,
                ...(borderRadius && rounded(borderRadius)),
                ...(flexbox && {
                  display: 'flex',
                }),
                ...(column && {
                  flexDirection: 'column',
                }),
                ...(flexCenter && {
                  justifyContent: 'center',
                  alignItems: 'center',
                }),
                ...(spaceBetween && {
                  justifyContent: 'space-between',
                }),
                ...(cursor && {
                  cursor,
                }),
                ...(alignCenter && {
                  alignItems: 'center',
                }),
                ...(justifyCenter && {
                  justifyContent: 'center',
                }),
                ...(zIndex && {
                  zIndex,
                }),
                ...(border && {
                  ...borderStyle(
                    border.color || colors.gray700,
                    border.width,
                    border.style
                  ),
                }),
                ...(userSelect && {
                  userSelect,
                }),
              },
            },
          },
          overrides
        )}
        {...props}
      >
        {children}
      </Block>
    )
  }
)

export const BaseBlock = React.memo(BaseBlockComponent)
